import React from 'react';
import ContentLoader from 'react-content-loader';
import { Table, Card, OverlayTrigger, Form, Col, Tooltip } from 'react-bootstrap';

import Header from '../Header';
import Footer from '../Footer';
import CategoryModals from '../CategoryModals';
import AdminModals from '../Administrators/AdminModals';
import Button from '../../../core-components/Button';
import Icon from '../../../core-components/Icon';
import Image from '../../../core-components/Image';
import Pagination from '../../../core-components/Pagination';

import styles from './ManageTags.module.scss';

export default class extends React.Component {
  pageSizes = [10, 25, 50, 100];
  defaultPageSize = this.pageSizes[0];
  maxPageSize = this.pageSizes[this.pageSizes.length - 1];
  minimumSearchQueryLength = 3;

  constructor(props) {
    super(props);
    this.state = {
      pageSize: this.pageSizes[0],
      pageNumber: 0,
      query: '',
      count: 0,
      data: [],
      isData: true,
      loading: true,
      modalShow: false,
      modalTitle: null,
      modalSubTitle: null,
      modalShowStatus: false,
      modalButton: null,
      id: null,
      selectedRow: null,
      info: ''
    };
  }

  modalToggle = (modalTitle, modalSubTitle, modalButton, index, row, info = '') => {
    this.setState({
      modalShow: true,
      modalTitle: modalTitle,
      modalSubTitle: modalSubTitle,
      modalButton: modalButton,
      id: index,
      selectedRow: { category: row },
      info
    });
  };

  modalHide = (value) => {
    if (value === 'reload tag') {
      this.setState({
        modalShowStatus: true,
        modalShow: false
      });
      this.fetchTags(this.state.pageSize, this.state.pageNumber);
    } else {
      this.setState({
        modalShow: false
      });
    }
  };

  modalHideStatus = () => {
    this.setState({
      modalShowStatus: false
    });
  };

  componentDidMount() {
    this.props?.invalidateTags();
    let limit = this.state.pageSize;
    let offset = this.state.pageNumber;
    this.fetchTags(limit, offset);
  }

  fetchTags(limit, offset) {
    this.props?.getTags(limit, offset).then(() => {
      this.setState({
        data: this.props?.tags?.categories,
        count: this.props?.tags?.totalCategories,
        loading: this.props?.tags?.loading,
        isData: this.props?.tags?.totalCategories === 0 ? false : true
      });
    });
  }

  paginate(limit, offset) {
    this.setState({
      loading: true
    });
    this.fetchTags(limit, offset);
  }

  render() {
    const { pageNumber, pageSize, count, data, loading } = this.state,
      pageSizeOptions = [];
    let index = 0;

    do {
      const value = this.pageSizes[index] > count ? count : this.pageSizes[index];
      if (!value) break;
      pageSizeOptions.push(
        <option key={index} value={value}>
          {value}
        </option>
      );
    } while (this.pageSizes[index++] < count);

    return (
      <>
        <AdminModals
          show={this.state.modalShowStatus}
          onHide={this.modalHideStatus}
          content={
            this.state.modalTitle === 'Edit Tag'
              ? 'Tag has been updated successfully'
              : this.state.modalTitle === 'Delete Tag'
              ? 'Tag deleted successfully'
              : 'Tag created successfully'
          }
        />
        <Card className={styles.manageCatCard}>
          <nav className={styles.manageCatCardHeader}>
            <div className={styles.headerComp}>{'Manage Tags'}</div>
            <Button
              className={styles.createButton}
              onClick={() => this.modalToggle('Create Tag', 'Name', 'Create')}
            >
              {'+ Create Tag'}
            </Button>
          </nav>
          <CategoryModals
            show={this.state.modalShow}
            onHide={this.modalHide}
            title={this.state.modalTitle}
            subTitle={this.state.modalSubTitle}
            button={this.state.modalButton}
            categoryId={this.state.id}
            category={this.state.selectedRow}
            info={this.state.info}
            placeholder={'Tag Name'}
          />
          <Card className={styles.tableCard}>
            <Table className={styles.manageCategoryTable}>
              <thead>
                <tr>
                  <th>Tags</th>
                  <th className={styles.alignRight}>Candidates</th>
                  <th className={styles.alignRight}>Actions</th>
                </tr>
              </thead>
              {this.state.isData ? (
                <tbody>
                  {loading
                    ? Array.apply(null, { length: pageSize })
                        .map(Number.call, Number)
                        .map((loadData, i) => {
                          return (
                            <tr key={i}>
                              <td className={styles.mainField}>
                                <ContentLoader height={20} width={80}>
                                  <rect x='0' y='0' width='80' height='14' />
                                </ContentLoader>
                              </td>
                              <td className={styles.alignRight}>
                                <ContentLoader height={20} width={80}>
                                  <rect x='0' y='0' width='80' height='14' />
                                </ContentLoader>
                              </td>
                              <td className={styles.alignRight}>
                                <ContentLoader height={20} width={80}>
                                  <rect x='0' y='0' width='80' height='14' />
                                </ContentLoader>
                              </td>
                            </tr>
                          );
                        })
                    : data &&
                      data.map((rowData, i) => {
                        return (
                          <tr key={i}>
                            <td className={styles.mainField}>{rowData.category}</td>
                            <td className={styles.alignRight}>{rowData.candidatesCount}</td>
                            <td className={styles.alignRight}>
                              <div className={styles.icons}>
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id={'EditTag'}>
                                      <p>{'Edit'}</p>
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className={styles.icon}
                                    onClick={() =>
                                      this.modalToggle(
                                        'Edit Tag',
                                        'Name',
                                        'Save',
                                        rowData.id,
                                        rowData.category
                                      )
                                    }
                                  >
                                    <Icon
                                      icon={'EditCategory'}
                                      color={'#333333'}
                                      width={14}
                                      height={14}
                                    />
                                  </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id={'DeleteTag'}>
                                      <p>{'Delete'}</p>
                                    </Tooltip>
                                  }
                                >
                                  <div
                                    className={styles.icon}
                                    onClick={() => {
                                      this.modalToggle(
                                        'Delete Tag',
                                        'Are you sure you want to delete this Tag?',
                                        'Delete',
                                        rowData.id,
                                        rowData.category,
                                        'Candidates associated with this tag won’t be deleted, but the tag itself will be removed from them.'
                                      );
                                    }}
                                  >
                                    <Icon
                                      icon={'DeleteCategory'}
                                      color={'#333333'}
                                      width={12}
                                      height={14}
                                    />
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      <div className={styles.noDataWrapper}>
                        <Image name={'NoData.svg'} />
                        <div className={styles.noDataContent}>{'No tags found'}</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
            {this.state.isData ? (
              <Form.Row className={styles.paginationWrapper}>
                <Col className={styles.showPagination}>
                  Show
                  <select
                    className={styles.selectPagination}
                    value={pageSize}
                    onChange={(event) => {
                      this.setState(
                        {
                          pageNumber: 0,
                          pageSize: parseInt(event.target.value)
                        },
                        this.paginate(event.target.value, 0)
                      );
                    }}
                  >
                    {pageSizeOptions}
                  </select>
                  items of {count}
                </Col>
                <Col>
                  <Pagination
                    forcePage={pageNumber}
                    onPageChange={({ selected }) =>
                      this.setState({ pageNumber: selected }, this.paginate(pageSize, selected))
                    }
                    pageCount={count / pageSize}
                  />
                </Col>
                <Col xs='3'></Col>
              </Form.Row>
            ) : null}
          </Card>
        </Card>
      </>
    );
  }
}
